import { HFModelData } from 'types/model';

export const ORDER_STATUS_ON_EXPERIMENT = 'pcp_order_status';

export const useOrderStatusOn = (model: HFModelData): boolean =>
  Boolean(model.experiments?.find(experiment => experiment.internalId === ORDER_STATUS_ON_EXPERIMENT));
